var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23576 11.7863L8.57147 14.1113C8.71478 14.2581 8.89396 14.3651 9.09127 14.4214C9.28859 14.4778 9.4972 14.4817 9.69648 14.4327C9.89699 14.3861 10.0821 14.2887 10.2341 14.1498C10.3861 14.011 10.4998 13.8353 10.5643 13.6398L14.4 2.14341C14.4801 1.928 14.4966 1.69414 14.4476 1.46962C14.3987 1.24509 14.2862 1.03936 14.1237 0.876863C13.9612 0.714368 13.7555 0.601948 13.531 0.552967C13.3065 0.503985 13.0726 0.520502 12.8572 0.600553L1.36076 4.43627C1.15853 4.50534 0.978413 4.62717 0.839026 4.78916C0.69964 4.95115 0.606041 5.14742 0.567903 5.3577C0.528538 5.54894 0.537302 5.74696 0.593406 5.93397C0.64951 6.12099 0.751198 6.29113 0.889332 6.42912L3.82505 9.36484L3.72862 13.0827L6.23576 11.7863Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0571 0.835938L3.82495 9.36451",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact-icon.9d669eda58a51a56002b114cc66acc25.svg";
export { ForwardRef as ReactComponent };